import React, { useState, useEffect, Fragment, memo } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import moment from 'moment';
import withErrorHandler from '../../../hoc/withErrorHandler/withErrorHandler';
import get from 'lodash/get';
import GlobalUploadComp from '../../../common/components/GlobalUploadComp/GlobalUploadComp';
const initialImg = '/images/icons/upload_new.svg';
import _ from 'lodash';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import { rotatge_45_clock } from '../LoginDetails/LogInDetails.module.css';
import {
  uploadDisbursementDocs,
  uploadedDisbusementDocs,
  UploadFileToS3,
  saveDisbursementApi,
  getDisbursementDetailsApi,
  markAsFullyDisbursed
} from '../../../common/constants/api';
import { getApplicantionInfo } from '../../../common/utils/applicantionInfo';
import PopUp from '../../../common/components/PopUp/PopUp';
import { numberFormat } from '../../../common/constants/NumberFormat';
import ShowGetImage from '../../../common/components/ShowGetImage/ShowGetImage';

import Modal from '../../../common/components/Modal/modal';
import RecuringDisbursement from './RecuringDisbursement';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle } from '@fortawesome/pro-light-svg-icons';
import './Disbursement.css';
import ShowDoc from '../../../containers/CMDashboard/ShowDoc';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';
import CMRejectLead from '../CMRejectLead/CMRejectLead';

const updateLeadStatus = async setTriggerStatusUpdate => {
  if (localStorage.hasOwnProperty('applicantionInfo')) {
    let leadInfo = JSON.parse(localStorage.getItem('applicantionInfo'));
    leadInfo.applicationStatus = 'Disbursed';
    localStorage.setItem('applicantionInfo', JSON.stringify(leadInfo));
    setTriggerStatusUpdate('Disbursed');
  } else {
    throw new Error('applicationInfo Key word error in local storage');
  }
};

const Disbursement = ({ setTriggerStatusUpdate }) => {
  const [getresponse, setResponse] = useState('');

  const [showAllDetails, setShowAllDetails] = useState(false);
  const [leadId, setLeadId] = useState(getApplicantionInfo().leadId);
  const [show, setShow] = useState(false);
  const [type, setType] = useState('loading');
  const [text, setText] = useState('loading...');
  const [dontClose, setDontClose] = useState(false);
  const [propertyId, setPropertyId] = useState(null);
  const [ownContributionId, setOwnContributionId] = useState(null);
  const [form26Id, setForm26Id] = useState(null);
  const [cancelledChequeId, setCancelledChequeId] = useState(null);
  const [getpropertyLink, setPropertyLink] = useState();
  const [ownContributionLink, setOwnContributionLink] = useState(null);
  const [form26Link, setForm26Link] = useState(null);
  const [cancelledChequeLink, setCancelledChequeLink] = useState(null);
  const [propertyEdit, setPropertyEdit] = useState(false);
  const [OCREdit, setOCREdit] = useState(false);
  const [TDSEdit, setTDSEdit] = useState(false);
  const [cacelledChequeEdit, setCacelledChequeEdit] = useState(false);
  const [fullImage, setFullImage] = useState(false);
  const [imgLinkData, setImgLinkData] = useState('');
  const [showRejectModal, setShowRejectModal] = useState(false);

  const documentList = [
    {
      label: 'Property FCU',
      index: 0,
      url: getpropertyLink ? getpropertyLink : '',
      edit: propertyEdit,
      editFunc: setPropertyEdit
    },
    {
      label: 'Own contribution Receipt(OCR)',
      index: 1,
      url: ownContributionLink ? ownContributionLink : '',
      edit: OCREdit,
      editFunc: setOCREdit
    },
    {
      label: 'Form 26 QB (TDS)',
      index: 2,
      url: form26Link ? form26Link : '',
      edit: TDSEdit,
      editFunc: setTDSEdit
    },
    {
      label: 'Cancelled Cheque',
      index: 3,
      url: cancelledChequeLink ? cancelledChequeLink : '',
      edit: cacelledChequeEdit,
      editFunc: setCacelledChequeEdit
    }
  ];
  const validationSchema = Yup.object().shape({
    file: Yup.array().test(value => {
      let isTrue = true;
      if (!getpropertyLink && !_.get(value, '[0][0]', false)) isTrue = false;
      if (!ownContributionLink && !_.get(value, '[1][0]', false))
        isTrue = false;
      if (!cancelledChequeLink && !_.get(value, '[3][0]', false))
        isTrue = false;
      return isTrue;
    }),
    amount: Yup.number().required('required')
  });
  return (
    <Formik
      initialValues={{
        file: [],
        imgUrl: [],
        sanctionAmount:
          parseInt(getApplicantionInfo()?.sanctionedAmount) + 1 || 0
      }}
      validationSchema={validationSchema}
    >
      {({
        values,
        handleChange,
        errors,
        touched,
        handleBlur,
        setFieldError,
        setFieldValue,
        setFieldTouched,
        handleSubmit,
        isSubmitting
      }) => {
        const [ShowModal, setShowModal] = useState(false);
        const [showDisbursementQue, setShowDisbursementQue] = useState(false);
        const addDisbursement = () => {
          setShowModal(true);
        };
        const markDisbursement = () => {
          setShowDisbursementQue(true);
        };
        const markDisbursementNo = () => {
          setShowDisbursementQue(false);
        };
        const markDisbursementYes = () => {
          setShowDisbursementQue(false);
          setShow(true), setType('loading');
          setText('Marking as fully disbursement. Please wait...');
          markAsFullyDisbursed(leadId)
            .then(res => {
              setShow(false);
              getDisbursementDetails();
            })
            .catch(error => {
              setShow(false);
            });
        };
        useEffect(() => {
          let data = getApplicantionInfo();
          if (data?.loanAmount) {
            setFieldValue('loanAmount', parseInt(data.loanAmount) + 1);
          }
        }, []);
        const statusforUpload = (data, docName) => {
          uploadedDisbusementDocs(leadId, docName, data?.requestId)
            .then(res => {
              let body = {};
              if (res?.error) {
                throw new Error(res);
              }
              if (docName == 'property-fcu') {
                setPropertyId(data?.requestId);
                body = {
                  propertyFcuDocId: data?.requestId
                };
              }
              if (docName == 'own-contribution') {
                setOwnContributionId(data?.requestId);
                body = {
                  ownContributionReceiptDocId: data?.requestId
                };
              }
              if (docName == 'form-26') {
                setForm26Id(data?.requestId);
                body = {
                  form26QbDocId: data?.requestId
                };
              }
              if (docName == 'cancelled-cheque') {
                setCancelledChequeId(data?.requestId);
                body = {
                  cancelledChequeDocId: data?.requestId
                };
              }
              setType('success');
              setText('File uploaded successfully.');
              setShow(true);
            })
            .catch(async err => {
              setShow(false);
            });
        };
        const uploadFileToS3 = (data, file, docName) => {
          if (data?.url && data?.requestId) {
            UploadFileToS3(data.url, file)
              .then(res => {
                if (res?.error) {
                  throw new Error(res);
                }
                statusforUpload(data, docName);
              })
              .catch(async err => {
                setShowModal(false);
                setShow(false);
              });
          }
        };

        const getS3Url = (index, docName) => {
          if (values?.file[index] && values?.file[index][0]) {
            setType('loading');
            setText('Uploading the File Please Wait...');
            setShow(true);
            let file = values?.file[index][0];
            uploadDisbursementDocs(leadId, docName)
              .then(res => {
                if (res?.error) {
                  throw new Error(res);
                }
                uploadFileToS3(res, file, docName);
              })
              .catch(async err => {
                setShowModal(false);
                setShow(false);
              });
          }
        };

        useEffect(() => {
          getS3Url(0, 'property-fcu');
        }, [values?.file[0]]);
        useEffect(() => {
          getS3Url(1, 'own-contribution');
        }, [values?.file[1]]);
        useEffect(() => {
          getS3Url(2, 'form-26');
        }, [values?.file[2]]);
        useEffect(() => {
          getS3Url(3, 'cancelled-cheque');
        }, [values?.file[3]]);

        const getDisbursementDetails = () => {
          setType('loading');
          setText('Getting  submitted data Please Wait...');
          setShow(true);
          setDontClose(true);

          getDisbursementDetailsApi(leadId)
            .then(res => {
              if (res?.error) {
                throw new Error(res);
              }
              if (res) {
                setResponse(res?.disbursementEntries);
                setPropertyLink(res?.propertyFcuDoc?.url);
                setOwnContributionLink(res?.ownContributionDoc?.url);
                setForm26Link(res?.form26Doc?.url);
                setCancelledChequeLink(res?.cancelledChequeDoc?.url);
              }
              setShow(false);
            })

            .catch(err => {
              setShow(false);
            });
        };

        //get Api
        useEffect(() => {
          getDisbursementDetails();
        }, [leadId, showAllDetails]);
        const TableViewForDisbursement = props => {
          return (
            <table className="table-fixed disbursement-data font-roboto text-black-400">
              <thead>
                <tr>
                  <th className="w-1/12 px-4 py-2 text-black-400">S.No</th>
                  <th className="w-3/12 px-4 py-2 text-black-400">
                    Transaction Id
                  </th>
                  <th className="w-3/12 px-4 py-2 text-black-400">
                    Disbursement Date
                  </th>
                  <th className="w-3/12 px-4 py-2 text-black-400 text-right">
                    Disbursement Amount
                  </th>
                  <th className="w-3/12 px-4 py-2 text-black-400 text-right">
                    Attached Doc
                  </th>

                  <th className="w-2/12 px-4 py-2 text-black-400">Comment</th>
                </tr>
              </thead>
              <tbody>
                {props?.data?.disbursements?.map((each, index) => {
                  return (
                    <tr>
                      <td>{index + 1}</td>
                      <td>{each?.transactionId || 'NA'}</td>
                      <td>
                        {moment(each?.disbursedDate).format('MMM D, YYYY') ||
                          'NA'}
                      </td>
                      <td className="text-right">
                        &#8377;{' '}
                        {numberFormat(parseInt(each?.disbursedAmount)) || 'NA'}
                      </td>
                      <td className="text-left ">
                        <p
                          className="pl-3"
                          onClick={async () => {
                            await setFieldValue('dataUrl', each?.proofDocUrl);
                            setFullImage(true);
                          }}
                        >
                          {each?.proofDocUrl ? (
                            <p className="text-blue-900 font-roboto text-sm cursor-pointer">
                              View
                            </p>
                          ) : (
                            '---'
                          )}
                        </p>
                      </td>

                      <td>{each?.comment || 'NA'}</td>
                    </tr>
                  );
                })}
                <tr>
                  <td colspan="3" className="text-right font-bold">
                    Total
                  </td>
                  <td className="text-right font-bold">
                    &#8377;{' '}
                    {numberFormat(parseInt(props?.data?.totalDisbursed))}
                  </td>
                </tr>
              </tbody>
            </table>
          );
        };
        const HtmlTooltip = withStyles(theme => ({
          tooltip: {
            backgroundColor: '#f5f5f9',
            color: 'rgba(0, 0, 0, 0.87)',
            maxWidth: 220,
            fontSize: theme.typography.pxToRem(12),
            border: '1px solid #dadde9'
          }
        }))(Tooltip);

        const RejectedLead = () => {
          return (
            <div className=" block md:table  mr-auto md:ml-auto md:mr-1 w-full md:w-auto">
              <HtmlTooltip
                title={
                  <div>
                    <p className="font-roboto font-normal text-balck-500 text-xs ">
                      You can again Login the lead to other bank after
                      rejection.
                    </p>
                  </div>
                }
              >
                <Button
                  onClick={() => setShowRejectModal(true)}
                  variant="contained"
                  color="secondary"
                  className="font-roboto font-light my-4 py-2 px-4 mr-2 rounded cursor-pointer max-w-xs normal-case w-full text-left block pl-6 "
                >
                  Reject Lead
                </Button>
              </HtmlTooltip>
            </div>
          );
        };

        return (
          <Form autoComplete="off">
            <div className="md:w-8/12 w-full bg-white my-4 px-10 min-h-screen border-grey-1009 border rounded bg-blue-1210 md:bg-white">
              <div className="flex flex-col md:flex-row md:justify-between mb-4 flex-wrap">
                <div className="font-roboto font-medium text-base text-black-850 my-4">
                  Disbursement Details
                </div>
                {['Disbursed'].includes(
                  getApplicantionInfo()?.applicationStatus
                ) && <RejectedLead />}
                {!getresponse?.isFullyDisbursed && (
                  <div className="flex flex-col md:flex-row justify-start">
                    <div
                      className="font-roboto font-light my-4 bg-green-900 hover:shadow-lg text-white py-2 px-4 rounded cursor-pointer mr-2 max-w-xs"
                      onClick={markDisbursement}
                    >
                      <span className="ml-2">Mark As Fully Disbursed</span>
                    </div>
                    <div
                      className="font-roboto font-light my-4 bg-orange-50 text-orange-600  hover:shadow-lg py-2 px-4 rounded cursor-pointer max-w-xs"
                      onClick={addDisbursement}
                    >
                      <span>
                        <FontAwesomeIcon icon={faPlusCircle} />
                      </span>
                      <span className="ml-2">Add Disbursement</span>
                    </div>
                  </div>
                )}
              </div>
              {getresponse ? (
                <div className="overflow-auto">
                  <TableViewForDisbursement data={getresponse} />
                </div>
              ) : (
                ''
              )}
              <div className="w-full flex mt-8 flex-wrap  justify-evenly">
                {documentList?.map((each, index) => {
                  if (!each?.url && getresponse?.isFullyDisbursed) return;
                  return (!each?.url || each?.edit) &&
                    !getresponse?.isFullyDisbursed ? (
                    <div className="table px-1 my-3 " key={index}>
                      <p className="w-full text-sm font-roboto font-normal text-grey-300 mb-2">
                        {each?.label}
                      </p>
                      <div className={`flex`}>
                        <GlobalUploadComp
                          data={values}
                          imgIndex={each?.index} //0,1,2,3 depending upon the no of file sequence
                          errors={errors}
                          touched={touched}
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          setFieldValue={setFieldValue}
                          setFieldTouched={setFieldTouched}
                          setFieldError={setFieldError}
                          initialImg={initialImg} // initial image
                          subInst="click here or  drop here to upload "
                        />
                      </div>
                    </div>
                  ) : (
                    <div className="table w-auto md:w-75  md:h-44 px-1 my-3 mt-8 ">
                      <p className="w-full text-sm font-roboto font-normal text-grey-300 mb-2 text-center">
                        {each?.label}
                      </p>

                      <ShowGetImage
                        img={each?.url}
                        setEdit={each?.editFunc}
                        showInPopUP={true}
                        editBtn={!getresponse?.isFullyDisbursed}
                      />
                    </div>
                  );
                })}
              </div>
            </div>
            <Modal
              show={ShowModal}
              setShow={setShowModal}
              xl={true}
              title={
                <span className="text-lg font-medium">Add Disbursement</span>
              }
              styleContainer={{
                maxHeight: '90%',
                overflow: 'auto'
              }}
              modalStyle={{ zIndex: 10000 }}
            >
              <RecuringDisbursement
                setShow={setShow}
                setType={setType}
                setText={setText}
                setShowModal={setShowModal}
                successCall={getDisbursementDetails}
              />
            </Modal>
            <PopUp
              type={type}
              text={text}
              setShow={setShow}
              show={show}
              autoClose={type === 'success'}
            />
            <Modal
              show={showDisbursementQue}
              setShow={setShowDisbursementQue}
              styleContainer={{
                width: '395px'
              }}
              noCloseBtn={false}
            >
              <React.Fragment>
                <div className="w-full text-center">
                  <p className="font-roboto text-lg font-bold text-black-400 border-b border-grey-200 text-center py-4">
                    Mark Final Disbursement
                  </p>
                  <p className="font-roboto font-normal text-black-400 text-center py-2 mt-2">
                    This will mark the application as Fully Disbursed and cannot
                    be undone.
                  </p>
                  <p className="font-roboto font-medium text-black-400 text-center py-1 mt-1">
                    Are you sure you want to proceed?
                  </p>
                </div>
                <div className="w-full flex justify-end mt-8">
                  <button
                    className="text-black-100 mr-2 px-8 py-2 border border-grey-200 rounded-md font-roboto font-normal hover:bg-grey-100"
                    onClick={markDisbursementNo}
                  >
                    No
                  </button>
                  <button
                    className="bg-tealCol-100 border text-white rounded-md font-roboto font-normal px-8 py-2 hover:bg-green-1100"
                    onClick={markDisbursementYes}
                  >
                    Yes
                  </button>
                </div>
              </React.Fragment>
            </Modal>

            {fullImage && (
              <ShowDoc
                file={values?.dataUrl}
                show={fullImage}
                setShow={setFullImage}
                autoCheck={true}
              />
            )}
            <CMRejectLead show={showRejectModal} setShow={setShowRejectModal} />
          </Form>
        );
      }}
    </Formik>
  );
};
export default memo(withErrorHandler(Disbursement));
